import { CommonModule } from '@angular/common';
import { AfterContentInit, ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { UmbracoIcon, UmbracoImage } from 'src/core-lib/umbraco/umbraco-image.model';
import { DialogModule } from 'src/layout/dialog/dialog.module';
import { MediaModule } from 'src/layout/media/media.module';
import { MarketSegment } from 'src/utils/market-segment.util';
import { ContentCacheUtils } from 'src/utils/storage.util';
@Component({
    selector: 'app-market-segment-selector',
    standalone: true,
    imports: [DialogModule, CommonModule, TranslateModule, MediaModule],
    templateUrl: './market-segment-selector.component.html',
    styleUrl: './market-segment-selector.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MarketSegmentSelectorComponent implements AfterContentInit {
    segments: MarketSegment.Type[];
    media: UmbracoImage | UmbracoIcon;
    description: string;

    constructor() {
        this.segments = MarketSegment
            .getSegments();
        this.media = ContentCacheUtils
            .system<{ marketSegmentMedia: UmbracoImage | UmbracoIcon }>().marketSegmentMedia;
        this.description = ContentCacheUtils
            .system<{ marketSegmentDescription: string }>().marketSegmentDescription;
    }

    ngAfterContentInit(): void {


                if (!MarketSegment
                    .isSelected())
                    setTimeout(() => {

                        if (window['market-segment-selector'] == null)
                            this.ngAfterContentInit();
                        else
                            window['market-segment-selector']?.showModal();
                    }, 200);

    }

    async selectSegment(segment: MarketSegment.Type) {
        await MarketSegment.setSegment(segment);

        window['market-segment-selector'].close();
    }
}
